/* eslint-disable react/no-danger */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import { Button, Checkbox, Modal } from '@material-ui/core';
import styled, { css } from 'styled-components';
import React, { useRef, useState } from 'react';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import { NoEncryption } from '@mui/icons-material';
import JsPDF from 'jspdf';
import { useTranslation } from 'react-i18next';
import TaskItem from './TaskItem';
import { Tasks } from '../../data/Tasks';
import modal from '../Modal/Modal';
import { createNewGame } from '../../utils/global';
import GameSummaryLabels from '../../pages/Report/GameSummaryLabels'
import {
    X,
    Ellipse52,
    Ellipse48,
    Ellipse56,
    Ellipse54,
    Ellipse55,
    CancelProject,
    GoBack3Steps,
    Group48,
    DiamondSm,
    ThumbsUpIcon,
} from '../../Constants/assets';
import fetchConfig from '../../Constants/fetch';
import { Board } from '../../data/Board';

// Stylings
// small pop up styling
const InnerContainer = styled.div`
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    position: absolute;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const Content = styled.div`
    width: 80%;
    height: 90%;
`;
const Container = styled.div`
    height: ${props => props.height};
    ${'' /* border: 2px solid black; */}
`;

const Title = styled.div`
    font-weight: bold;
    font-size: 1.5rem;
    line-height: 1.8rem;
    display: flex;
    justify-content: space-between;
    height: 35%;
`;
const Paragraph = styled.div`
    font-weight: normal;
    font-size: 16px;
    line-height: 21.18px;
`;
const BodyLineContainer = styled.div`
    height: 25%;
    display: flex;
`;
const CircleImageContainer = styled.div`
    margin-right: 2%;
`;
const BodyTitle = styled.div`
    font-weight: 500;
    font-size: 1.188rem;
    line-height: 1.375rem;
    height: 30%;
`;
const BodySubTitle = styled.div`
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.188rem;
    display: flex;
`;
const DiamondContainer = styled.div`
    display: block;
`;
const FotterContainer = styled.div`
    height: 15%;
    width: 95%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;
const ExchangeButtonContainer = styled.button``;
const ExchangeButton = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: ${props => props.theme.colors.white};
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    width: 100%;
    height: 3.125rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
`;
const NewGameButton = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: ${props => props.theme.colors.darkGreen};
    background: ${props => props.theme.colors.white};
    border-radius: 4px;
    width: 100%;
    height: 3.125rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
`;

// Gate 2 styling:
const GateTwoBody = styled.div`
    height: 85%;
    overflow-y: auto;
`;

const InputChecked = styled.button`
    border: 0;
    ${props =>
        props.disabled
            ? css`
                  background: ${componentProps => componentProps.theme.colors.lightGray};
              `
            : css`
                  background: ${componentProps => componentProps.theme.colors.darkGreen};
                  cursor: pointer;
              `}
    border-radius: 4px;
    height: 50px;
    width: 198px;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    margin-right: 30px;
    color: ${props => props.theme.colors.white};
    :active {
        background: ${props => props.theme.colors.lightGray};
    }
`;
const ExecuteTaskContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 20%;
    align-items: center;
}
`;
const ErrorContainer = styled.div`
    // display: none;
`;
const ErrorHeadLine = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    color: ${props => props.theme.colors.red};
    width: 65%;
`;
const OptionContainer = styled.div`
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    text-decoration-line: underline;
    color: ${props => props.theme.colors.darkGreen};
    margin-top: 1%;
`;
// Gate 3 styling:
const ThumbsUpContainer = styled.div`
    height: 60%;
    text-align-last: center;
`;
const ThumbsUpParagraph = styled.div`
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.375rem;
    text-align: center;
`;
// Gates styling:
const InnerGatesContainer = styled.div`
    width: 90%;
    height: 85%;
    display: flex;
    mergin: 0 auto;
    justify-content: space-between;
`;
const BodyComponent = styled.div`
    display: grid;
    width: 83%;
    height: 100%;
    align-content: space-between;
}
`;
const HeaderComponent = styled.div`
    display: flex;
    justify-content: space-between;
`;
const ImageComponent = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
`;
const TitleComponent = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 24px;
`;
const ParagraphContainer = styled.div``;
const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;
// Temporary Css style until global Modal will work
const ModalContainer = styled.div`
    width: 600px;
    height: 320px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 2;
    animation: zoomIn 0.2s ease-in-out;
`;
const TextContainer = styled.div`
    height: 55%;
`;
const Br = styled.div`
    height: 15%;
`;
const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 50%;
    color: ${props => props.theme.colors.black};
    height: 25%;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    line-height: 135%;
    color: ${props => props.theme.colors.black};
    width: 85%;
    display: inline-table;
`;
const ModalButtonContainer = styled.button`
    width: 40%;
    height: 75%;
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 8px;
    cursor: pointer;
    border: none;
`;
const ButtonContainerLine = styled.div`
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: space-evenly;
`;
const GetStartedButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 2.05vh;
    color: ${props => props.theme.colors.white};
    width: 100%;
`;
// pdf style:

const PageInfo = styled(Grid)`
    margin: 24px auto;
    height: 100px;
    display: flex;
    justify-content: space-between;
`;
const Column = styled.div`
    display: grid;
    align-content: space-between;
    height: 100%;
`;
const ProjectNameComponent = styled.div`
    width: 100%;
`;
const TitleComponentPDF = styled.div`
    width: fit-content;
    display: flex;
    justify-content: space-between;
`;
const ArrowComponent = styled.div`
    width: 20px;
    display: flex;
    align-items: center;
`;
const SummaryDescriptionComponent = styled.div`
    /* width: 600px; */
`;
const PrintButton = styled.button`
    background-color: transparent;
    border: none;
`;
const SummaryDescription = styled.div`
    color: ${props => props.theme.colors.gray};
`;
const GameSummaryComponent = styled.div`
    text-decoration: underline;
    color: ${props => props.theme.colors.darkGreen};
    cursor: pointer;
    width: fit-content;
`;
const FieldComponent = styled.div`
    display: grid;
    max-width: fit-content;
`;
const Label = styled.div`
    color: ${props => props.theme.colors.gray};
    /* width: 190px; */
`;
const LabelLine = styled.div`
    display: flex;
    justify-content: space-between;
    direction: ltr;
`;
const PopUpContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

const ContentArea = styled.div`
    width: 100%;
    margin: 32px auto;
    height: 35rem;
    width: 93%;
`;
const HeaderContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: 9%;
`;
const HeaderTitle = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: #000000;
`;
const ColumnContainer = styled.div`
    height: 1.5rem;
`;
const InnerContainerPdf = styled.div`
    z-index: 0;
    width: 70rem;
    height:auto;
`;
const ContainerPdf = styled.div`
    margin: 0 4.2%;
    width: max-content !important;
    justify-content: center;
    @page {
        margin: 0cm;
    }
`;

const areAllChecked = () => {
    let isChecked = false;
    const checkbox = document.querySelectorAll('input[type=checkbox]');
    const checkboxesArray = [...checkbox];

    checkboxesArray.filter(current => {
        if (current.checked) {
            isChecked = true;
        }
    });

    return isChecked;
};

// TODO: Fix this, this is temporary fix
export default function Gates({
    socketIO,
    sideLogUpdate,
    saveGame,
    toggleProjectNeedToBeDisabled,
    actualGate,
    type,
    toggleResources,
    additionalBudget,
    generalCounter,
    commentAdditionalBudget,
    toggleGate,
    gateTasks,
    playerStatus,
    handlePlayerStatus,
    endTurn,
    handleCard,
    walkingAlgorithm,
    toggleSecondGateNeeded,
    handleGateNumber,
    playerCurrentId,
    toggleProject,
    onlyShowModal,
    secondGateControlNeeded,
    triviaToggle,
    getTriviaData,
    playerStatus2,
    isPlanning,
    SoundPlay,
    soundForFlipAndCards,
    toggleDelayCardAtFirstGateControl,
    toggleTriviaNotOpenIfDelay,
    delayCardIsTakenInGateControl,
    gateTextNeedToChange,
    toggleGateTextNeedToChange,
    endGameFunction,
    showEndGameModal,
    playerCurrentPosition,
    playerName,
    email,
    handleLogin,
    restartGameFunction,
    toggleReport,
    toggleNeedsToStartNewGame,
    playersFullName,
    gameStartTime,
    gameGoals,
    tasks,
    orTasks,
    generalTasks,
    unplannedCards,
    logSideBar,
    amountResourcesExpensive,
    shortReport,
    toggleSaveOnGate,
    turn,
    setTasksCounter,
    getReportTest,
    originTask,
    toggleSideLogAnimation,
    timeSeconds,
    pauseForPlanningTimer,
    timerFormat,
    getPlayerLog,
    projectScopeDisabled,
    toggleRestartHasBeenMadeNow,
    setGateTestResult,
    gateTestResult,
    setOneLessStep,
    hasExecuteRemainingTasksAtGateRef,
    advanceOfferedToGoBack,
    additionalBudgetCommentsInit,
    resourcesForDoublePriceCommentInit,
    askedForAdditionalInGate,
    setAskedForBudgetAtGate,
    setAskedForResourcesAtGate,
    plannedTaskStack,
    setPlannedTaskStack,
    tasksTimer,
    setTasksTimer,
    projectId,
    changeProject,
}) {
    // turnNumber for all of this page reffered to taskRowId from the db,
    // should be implemented a real turn number,
    // and create another row in the db to containt row id.
    const { t } = useTranslation();

    const [disableBtn, setDisableBtn] = useState(false);
    // additional budget:
    const [additionalBudgetValid, setAdditionalBudgetValid] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [modalBudgetContent, setModalBudgetContent] = useState(
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore',
    );
    const [modalBudgetTitle, setModalBudgetTitle] = useState('Are you sure?');
    const [gateLogRowId, setGateLogRowId] = useState(0);
    const [additionalBudgetPopUp, setAdditionalBudgetPopUp] = useState(false);
    const ModalBudgetContainer = styled.div`
        position: absolute;
        z-index: 2;
    `;
    const curretTile = Board[playerCurrentPosition];
    const [stage, setStage] = useState(1);
    const [newPlayerStatus, setNewPlayerStatus] = useState(playerStatus);
    // const [gateTestResult, setTestResult] = useState(null);
    const [isCheckBoxChecked, setIsCheckBoxChecked] = useState(false);
    const [isTaskCompletedAtGate, setIsTaskCompletedAtGate] = useState(false);
    const [modalContent, setModalContent] = useState(t("modals.end_of_turn.info_text"));
    const [modalTitle, setModalTitle] = useState(t("modals.end_of_turn.info_title"));
    const finalGateActionTime = useRef(0)
    const newTaskData = Tasks.filter(
        current => current.constraint === type && current.isChecked === false,
    );

    const handleIsChecked = () => {
        setIsCheckBoxChecked(areAllChecked());
    };
    const handleTwoStages = () => {
        setStage(currentStage => currentStage + 2);
    };
    const handleStage = () => {
        setDisableBtn(false)
        setStage(currentStage => currentStage + 1);
    };

    const budgetAndResourcesCommentsTest = async (parentId) => {
        if (askedForAdditionalInGate.budget) {
            await additionalBudgetCommentsInit(parentId);
            setAskedForBudgetAtGate(false);
        }
        if (askedForAdditionalInGate.resources) {
            await resourcesForDoublePriceCommentInit(parentId);
            setAskedForResourcesAtGate(false);
        }
    }

    const commentActionTime = async (actionTime) => {
        const baseUrl = `${fetchConfig.prefix}/game/comment_action_time`;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'action time for current gate',
            taskRowId: gateLogRowId,
            actionTime,
        };
        const result = await axios.get(
            `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                data.commentContent,
            )}&taskRowId=${data.taskRowId}&actionTime=${data.actionTime}`,
            data,
        );
    };

    const commentProjectCanceled = async () => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'Project Canceled due to low project value',
            taskRowId: gateLogRowId,
        };
        const result = await axios.get(
            `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                data.commentContent,
            )}&taskRowId=${data.taskRowId}`,
            data,
        );

        axios.post(`${fetchConfig.prefix}/game/cancel_saved_game`, {
            gameId: playerStatus.gameId,
        });
    };
    const isNewTaskDataEmpty = () => {
        console.log("hi yoni1", delayCardIsTakenInGateControl, gateTasks, stage);
        if (!delayCardIsTakenInGateControl) {
            toggleGateTextNeedToChange(true);
        }
        if (gateTasks.length > 0 && !delayCardIsTakenInGateControl || delayCardIsTakenInGateControl && gateTasks == 0) {
            handleTwoStages();
        } else if (delayCardIsTakenInGateControl && gateTasks > 0) {
            handleStage();
        } else {
            handleStage(); // not suppose to happen.
        }
    };

    const executeRemainingTasks = async (callback = () => { }) => {
        // change ref to true for 1 time 
        // eslint-disable-next-line no-param-reassign
        hasExecuteRemainingTasksAtGateRef.current = true;
        const idTasks = gateTasks.map(element => element.value[0].id);
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            tasksIds: idTasks,
            turn,
            playerPosition: playerStatus.position,
        };
        const result = await axios.post(`${fetchConfig.prefix}/game/perform_gate_tasks`, data);
        const setTasks = idTasks && idTasks.length > 0 ? setTasksCounter(idTasks.length + generalCounter) : null;
        const taskIds = tasks.filter(task => idTasks.includes(task.taskIdnumberInDB)).map(task => task.id);
        console.log("okok", result, gateTasks, idTasks, taskIds, plannedTaskStack)
        console.log("after filtration", plannedTaskStack.filter(task => !taskIds.includes(task)));
        setPlannedTaskStack(plannedTaskStack.filter(task => !taskIds.includes(task)));
        handlePlayerStatus(
            result.data[0].earnedValue,
            result.data[0].regular,
            result.data[0].senior,
            result.data[0].expensive,
            result.data[0].budget,
            result.data[0].location,
        );
        // await additionalBudgetCommentsInit(result.data[1]);
        // await resourcesForDoublePriceCommentInit(result.data[1]);
        handleStage();
    };

    const executeGateCheck = async () => {
        console.log("got action time!", finalGateActionTime)
        const shownResults = {
            1: 'Move forward!',
            2: 'Delay',
            3: 'Go Back',
            4: 'Project is cancelled!',
        };
        const tileGateObj = curretTile.gate;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            gateNumber: actualGate,
            playerCurrentPosition,
            tileGateObj,
            turn,
            actionTime: finalGateActionTime.current
        };
        const result = await axios.post(`${fetchConfig.prefix}/game/gate_test`, data);
        setGateLogRowId(result.data[2]);
        if (!(typeof result.data[0] === 'string')) {
            setTimeout(() => {
                setNewPlayerStatus(result);
            }, 100);

            setGateTestResult(shownResults[result.data[1]]);
            if (shownResults[result.data[1]] === 'Go Back') {
                advanceOfferedToGoBack()
            }
            sideLogUpdate(false);
            toggleSideLogAnimation("gate");
        } else {
            setGateTestResult(shownResults[4]);
        }
        getTriviaData();
        handleStage();
        budgetAndResourcesCommentsTest(result.data[2]);
    };

    const handleGateEnd = (isSpacialCard, newGame, commentit = () => { }) => {
        finalGateActionTime.current = timeSeconds.current - tasksTimer;
        commentActionTime(timeSeconds.current - tasksTimer);
        console.log("gate action time!!!!", finalGateActionTime.current, tasksTimer, timeSeconds.current);
        if (isSpacialCard) {
            console.log("hi yoni9.1", stage, actualGate, secondGateControlNeeded);
            console.log("only after special?");
            triviaToggle(true);
            SoundPlay(soundForFlipAndCards);
        }
        if (gateTestResult === 'Move forward!') {
            handleGateNumber(actualGate + 1);
            // walkingAlgorithm(1, playerStatus.position, newPlayerStatus, true, false);
        } else if (gateTestResult === 'Delay') {
            toggleSecondGateNeeded(true);
            triviaToggle(false);
            commentit(gateLogRowId);
            handleCard('Delay');
        } else if (gateTestResult === 'Go Back') {
            toggleSecondGateNeeded(true);
            triviaToggle(false);
            commentit(gateLogRowId);
            if (playerCurrentPosition > 3) {
                walkingAlgorithm(-3, playerStatus.position, newPlayerStatus, true, false);
            } else {
                walkingAlgorithm(-1, playerStatus.position, newPlayerStatus, true, false); // should be changed in the future for me dynamic game.
            }
            // handleCard('Delay');
        } else if (gateTestResult === 'Project is cancelled!' && !newGame) {
            endGameFunction(true, 0, 0, 'player didnt had enoughs value at gate', false);
            triviaToggle(false);
            // handleCard('Delay');
        }
        toggleProject(3);
        toggleGate(false);
        projectScopeDisabled(false);
    };

    const PDFExample = async () => {
        const gameRunTime = await timerFormat(timeSeconds.current);
        const planningTimer = await timerFormat(pauseForPlanningTimer);
        try {
            axios.get(`${fetchConfig.prefix}/game/end_game`, {
                params: {
                    reason: "project got canceled at gate due to low value",
                    timer: gameRunTime,
                    gameId: playerStatus.gameId,
                    userId: playerStatus.id,
                    planningTimer,
                },
            });
        } catch (e) {
            console.error("error in fetching end_game request, the error is: ", e);
        }

        getPlayerLog({
            gameAndUserIdObj: false,
            lastPlayData: false,
            needssummaryReport: true,
            sendByMail: true,
        });

        let instructorId = null;
        let accountId = null;
        try {
            const result = await changeProject(projectId);
            if (result) {
                instructorId = result.instructor_id;
                accountId = result.account_id;
            }
        } catch (error) {
            console.log('Error fetching project info:', error);
        }

        restartGameFunction(playerName, email, instructorId, accountId);
    };

    const commentGatePassedAfterCompletedTaskOnGate = async () => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'Gate passed after completing late tasks at the gate',
            taskRowId: gateLogRowId,
        };
        axios
            .get(
                `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                    data.commentContent,
                )}&taskRowId=${data.taskRowId}`,
                data,
            )
            .catch(error => console.log(error));
    };

    const commentDelayedAtGate = async () => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'Delayed at gate due to low project value',
            taskRowId: gateLogRowId,

        };
        axios
            .get(
                `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                    data.commentContent,
                )}&taskRowId=${data.taskRowId}`,
                data,
            )
            .catch(error => console.log(error));
    };

    const commentReturnFromGate = async () => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'Returned from gate due to low project value',
            playerPosition: playerStatus.position,
            taskRowId: gateLogRowId,
        };
        axios
            .get(
                `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                    data.commentContent,
                )}&playerPosition=${data.playerPosition}&taskRowId=${data.taskRowId}`,
                data,
            )
            .catch(error => console.log(error));
    };

    const handleGiveResourcesSecondGateControl = async () => {
        console.log("got action time!", finalGateActionTime)
        const tileGateObj = curretTile.gate;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            gateNumber: actualGate,
            playerCurrentPosition,
            tileGateObj,
            turn,
            actionTime: finalGateActionTime.current,
        };
        const result = await axios.post(`${fetchConfig.prefix}/game/gate_test_again`, data);
        // setTimeout(() => {
        setNewPlayerStatus(result);
        // }, 100);
        setGateTestResult('Move forward!');
        handleStage();
        budgetAndResourcesCommentsTest(result.data[2]);
    };



    const gateTestSteps = {
        high: curretTile.gate.rates.high,
        medium: curretTile.gate.rates.medium,
        low: curretTile.gate.rates.low,
    };

    const prizes = {
        regular: curretTile.gate.resources.standard,
        senior: curretTile.gate.resources.senior,
        expensive: curretTile.gate.resources.expensive,
        budget: curretTile.gate.resources.budget,
    };

    const tasksCost = {
        budget: 0,
        normal: 0,
        senior: 0,
        expensive: 0,
    };

    gateTasks.map(current => {
        tasksCost.budget += current.value[0].costMoney;
        tasksCost.normal += current.value[0].costResourcesNormal;
        tasksCost.senior += current.value[0].costResourcesSenior;
        tasksCost.expensive += current.value[0].costResourcesExpensive;
    });
    const canExecuteTasks =
        playerStatus.budget >= tasksCost.budget &&
        playerStatus.resources.regular >= tasksCost.normal &&
        playerStatus.resources.executive >= tasksCost.senior &&
        playerStatus.resources.expensive >= tasksCost.expensive;

    if (stage < 4 && !secondGateControlNeeded) {
        return (
            <InnerContainer
                style={{
                    width: stage == 1 ? '610px' : '37%',
                    height: stage == 1 ? '580px' : '80%',
                }}
            >
                <Content>
                    <Container height="25%">
                        <Title>
                            {t(`modals.gate.gate_info.title`) + actualGate}
                            {/* {stage !== 1 && (
                                <X
                                    onClick={() => toggleGate(false)}
                                    style={{ cursor: 'pointer' }}
                                />
                            )} */}
                        </Title>
                        {stage == 1 && (
                            <Paragraph style={{ width: '90%' }}>
                                {t(`modals.gate.gate_info.info_text`)}
                            </Paragraph>
                        )}
                        {stage == 2 && (
                            <Paragraph style={{ color: '#A90821' }}>
                                {t(`modals.gate.not_all_tasks_completed.info_text`)}
                            </Paragraph>
                        )}
                        {stage == 3 && <Paragraph />}
                    </Container>
                    {stage == 1 && (
                        <>
                            <Container height="65%">
                                <BodyLineContainer>
                                    <CircleImageContainer>
                                        <Ellipse52 />
                                    </CircleImageContainer>
                                    <div>
                                        <BodyTitle>{t(`modals.gate.gate_info.keep_playing`)}</BodyTitle>
                                        <BodySubTitle>
                                            {t(`modals.gate.gate_info.more_than`)} {gateTestSteps.high}
                                            <DiamondContainer>
                                                <DiamondSm />
                                            </DiamondContainer>
                                        </BodySubTitle>
                                    </div>
                                </BodyLineContainer>
                                <BodyLineContainer>
                                    <CircleImageContainer>
                                        <Group48 />
                                    </CircleImageContainer>
                                    <div>
                                        <BodyTitle>{t(`modals.gate.gate_info.take_a_delay_card`)}</BodyTitle>
                                        <BodySubTitle>
                                            {t(`modals.gate.gate_info.between`)} {gateTestSteps.medium}
                                            <DiamondContainer>
                                                <DiamondSm />
                                            </DiamondContainer>
                                            &nbsp; {t(`modals.gate.gate_info.and`)} {gateTestSteps.high}
                                            <DiamondContainer>
                                                <DiamondSm />
                                            </DiamondContainer>
                                        </BodySubTitle>
                                    </div>
                                </BodyLineContainer>
                                <BodyLineContainer>
                                    <CircleImageContainer>
                                        <GoBack3Steps />
                                    </CircleImageContainer>
                                    <div>
                                        <BodyTitle>{t(`modals.gate.gate_info.go_back_3_steps`)}</BodyTitle>
                                        <BodySubTitle>
                                            {t(`modals.gate.gate_info.between`)} {gateTestSteps.low}
                                            <DiamondContainer>
                                                <DiamondSm />
                                            </DiamondContainer>
                                            &nbsp;{t(`modals.gate.gate_info.and`)} {gateTestSteps.medium}
                                            <DiamondContainer>
                                                <DiamondSm />
                                            </DiamondContainer>
                                        </BodySubTitle>
                                    </div>
                                </BodyLineContainer>
                                <BodyLineContainer>
                                    <CircleImageContainer>
                                        <CancelProject />
                                    </CircleImageContainer>
                                    <div>
                                        <BodyTitle>{t(`modals.gate.gate_info.cancel_project`)}</BodyTitle>
                                        <BodySubTitle>
                                            {t(`modals.gate.gate_info.less_than`)} {gateTestSteps.low}
                                            <DiamondContainer>
                                                <DiamondSm />
                                            </DiamondContainer>
                                        </BodySubTitle>
                                    </div>
                                </BodyLineContainer>
                            </Container>
                            <FotterContainer>
                                <ExchangeButtonContainer
                                    style={{
                                        width: '283px',
                                        height: '50px',
                                        marginTop: '-30px',
                                        marginRight: '-25px',
                                        border: 'none',
                                    }}
                                >
                                    <ExchangeButton
                                        onClick={() => {
                                            setTasksTimer();
                                            toggleSaveOnGate(true);
                                            isNewTaskDataEmpty();
                                        }}
                                        style={{ width: '283px', height: '50px' }}
                                    >
                                        {t(`modals.gate.gate_info.button1`)}
                                    </ExchangeButton>
                                </ExchangeButtonContainer>
                            </FotterContainer>
                        </>
                    )}
                    {stage == 2 && (
                        <>
                            <Container height="75%">
                                <GateTwoBody>
                                    <Container height="30%">
                                        {gateTasks.map((current, index) => {
                                            return (
                                                <TaskItem
                                                    originTaskArray={originTask}
                                                    {...current}
                                                    handleIsChecked={handleIsChecked}
                                                    key={index}
                                                    isCheckBoxChecked
                                                />
                                            );
                                        })}
                                        {!canExecuteTasks && (
                                            <ErrorContainer>
                                                <ErrorHeadLine>
                                                    {t(`modals.gate.not_all_tasks_completed.cannot_execute_tasks`)}
                                                </ErrorHeadLine>
                                                <OptionContainer
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => toggleResources('Buy resources')}
                                                >
                                                    {t(`global_variables.get_resources_link`)}
                                                </OptionContainer>
                                                <OptionContainer
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        console.log("i am here1");
                                                        onlyShowModal(
                                                            "modals.additional_budget.info_title",
                                                            "modals.additional_budget.info_text",
                                                            "modals.additional_budget.button1",
                                                        )
                                                    }}
                                                >
                                                    {t(`global_variables.additional_budget_link`)}
                                                </OptionContainer>
                                            </ErrorContainer>
                                        )}
                                    </Container>
                                </GateTwoBody>
                                <ExecuteTaskContainer>
                                    <InputChecked
                                        disabled={canExecuteTasks}
                                        onClick={() => {
                                            handleCard('Delay');
                                            handleStage();
                                            console.log("hi yoni2", delayCardIsTakenInGateControl);
                                            toggleDelayCardAtFirstGateControl(false);
                                            toggleGate(false, true);
                                        }}
                                    >
                                        {t(`modals.gate.not_all_tasks_completed.button2`)}
                                    </InputChecked>
                                    <InputChecked
                                        disabled={!canExecuteTasks || disableBtn}
                                        onClick={() => {
                                            setDisableBtn(true);
                                            // setTimeout(() => setDisableBtn(false), 3000);
                                            executeRemainingTasks();
                                            // commentTaskCompletedAtGate();
                                            setIsTaskCompletedAtGate(true);
                                            // commentCancelProgressAtGate();
                                            toggleGateTextNeedToChange(false);
                                        }}
                                    >
                                        {t(`modals.gate.not_all_tasks_completed.button1`)}
                                    </InputChecked>
                                </ExecuteTaskContainer>
                            </Container>
                        </>
                    )}
                    {stage == 3 && !gateTextNeedToChange && (
                        <>
                            <ThumbsUpContainer>
                                <ThumbsUpIcon />
                                <ThumbsUpParagraph>
                                    {t(`modals.gate.tasks_completed.info_text`)}
                                </ThumbsUpParagraph>
                            </ThumbsUpContainer>
                            <ExecuteTaskContainer>
                                <InputChecked
                                    disabled={disableBtn}
                                    onClick={() => {
                                        executeGateCheck();
                                        // toggleDelayCardAtFirstGateControl(false);
                                        toggleTriviaNotOpenIfDelay(true);
                                        setDisableBtn(true);
                                        setTimeout(() => setDisableBtn(false), 10000);
                                    }}
                                >
                                    {t(`modals.gate.tasks_completed.button1`)}
                                </InputChecked>
                            </ExecuteTaskContainer>
                        </>
                    )}
                    {stage == 3 && gateTextNeedToChange && (
                        <>
                            <ThumbsUpContainer>
                                <ThumbsUpIcon />
                                <ThumbsUpParagraph>
                                    {t(`modals.gate.tasks_delayed.info_text`)}
                                </ThumbsUpParagraph>
                            </ThumbsUpContainer>
                            <ExecuteTaskContainer>
                                <InputChecked
                                    onClick={() => {
                                        executeGateCheck();
                                        // toggleDelayCardAtFirstGateControl(false);
                                        toggleTriviaNotOpenIfDelay(true);
                                        toggleGateTextNeedToChange(false);
                                        toggleSecondGateNeeded(true);
                                        return (null);
                                    }}
                                >
                                    {t(`modals.gate.tasks_delayed.button1`)}
                                </InputChecked>
                            </ExecuteTaskContainer>
                        </>
                    )}
                </Content>
            </InnerContainer>
        );
    }
    if (stage == 4) {
        return (
            <>
                <div style={{ visibility: 'hidden', position: 'fixed', width: '100%', height: '100%' }}>
                    <ContainerPdf id="fileSummary" style={{ position: 'absolute', top: '0' }}>
                        <div style={{ margin: '40px ' }}>
                            <PageInfo style={{}}>
                                <Column
                                    style={{
                                        width: '50%',
                                        height: '100%',
                                    }}
                                >
                                    <ProjectNameComponent>
                                        <TitleComponent>
                                            <Title>Company's &nbsp; website development</Title>
                                        </TitleComponent>
                                    </ProjectNameComponent>
                                    <SummaryDescriptionComponent>
                                        <SummaryDescription>
                                            Complete the project with a budget under $12,000 and up to
                                            step 40 on the board
                                        </SummaryDescription>
                                    </SummaryDescriptionComponent>
                                </Column>
                                <Column
                                    style={{
                                        width: '40%',
                                        height: '75%',
                                    }}
                                >
                                    <FieldComponent>
                                        <LabelLine>
                                            <Label>Game Date & Time:</Label>
                                            <Label>{new Date().toLocaleString()}</Label>
                                        </LabelLine>
                                    </FieldComponent>
                                    <FieldComponent>
                                        <LabelLine>
                                            <Label>Player Name:</Label>
                                            {(playersFullName === undefined || playersFullName.length < 1) && <Label>{playerName}</Label>}
                                            {(playersFullName != undefined && playersFullName.length >= 1) && <Label>{playersFullName}</Label>}
                                        </LabelLine>
                                    </FieldComponent>
                                    <FieldComponent>
                                        <LabelLine>
                                            <Label>Player Email:</Label>
                                            <Label>{email}</Label>
                                        </LabelLine>
                                    </FieldComponent>
                                </Column>
                            </PageInfo>
                        </div>
                        <div>
                            <PopUpContainer>
                                <InnerContainerPdf>
                                    <ContentArea>
                                        {Board[playerCurrentPosition].type == 'gate' && (
                                            <HeaderContainer>
                                                <HeaderTitle>Game got canceled &nbsp; due to low value &nbsp; at Gate # {Board[playerCurrentPosition].gate.id}</HeaderTitle>
                                            </HeaderContainer>
                                        )}
                                        <HeaderContainer>
                                            <HeaderTitle>Game Summary &nbsp; Stats</HeaderTitle>
                                        </HeaderContainer>
                                        <div style={{ display: 'flex', height: '4%' }}>
                                            <ColumnContainer
                                                style={{
                                                    width: '45%',
                                                }}
                                            />
                                        </div>
                                        {/* {(shortReport != undefined && shortReport.remainResources.senior != 999) && ( // we check if 'shortReport' values are from stage or from server
                                            <GameSummaryLabels
                                                gameStartTime={gameStartTime}
                                                playerFullName={playersFullName}
                                                playerEmail={email}
                                                playerName={playerName}
                                                logSideBar={logSideBar}
                                                amountResourcesExpensive={amountResourcesExpensive}
                                                tasksArray={tasks}
                                                shortReport={shortReport}
                                                data={logData}
                                                turnNum={logData.turnNum}
                                                gameGoals={gameGoals}
                                                tasks={tasks}
                                            />
                                        )} */}
                                    </ContentArea>
                                </InnerContainerPdf>
                            </PopUpContainer>
                        </div>
                    </ContainerPdf>
                </div>
                <InnerContainer
                    style={{ width: '540px', height: '450px' }}
                >
                    <InnerGatesContainer>
                        {gateTestResult === 'Move forward!' && (
                            <ImageComponent>
                                {' '}
                                {/* { } */}
                                <Ellipse52 />
                            </ImageComponent>
                        )}
                        {gateTestResult === 'Delay' && (
                            <ImageComponent>
                                {' '}
                                {/* { } */}
                                <Ellipse54 />
                            </ImageComponent>
                        )}
                        {gateTestResult === 'Go Back' && (
                            <ImageComponent>
                                {' '}
                                {/* { } */}
                                <Ellipse55 />
                            </ImageComponent>
                        )}
                        {gateTestResult === 'Project is cancelled!' && (
                            <ImageComponent>
                                {' '}
                                {/* { } */}
                                <Ellipse56 />
                            </ImageComponent>
                        )}
                        <BodyComponent>
                            {gateTestResult === 'Move forward!' && (
                                <>
                                    <HeaderComponent>
                                        <TitleComponentPDF>{t(`modals.gate_options.go_forward.info_title`)}</TitleComponentPDF>
                                    </HeaderComponent>
                                    <ParagraphContainer>
                                        {t(`modals.gate_options.go_forward.info_text`) + gateTestSteps.high}
                                        <DiamondSm />
                                        {t(`modals.gate_options.go_forward.info_text2`)}
                                        <br />
                                        {prizes.regular} {t(`modals.gate_options.go_forward.regular`)} <br />
                                        {prizes.senior} {t(`modals.gate_options.go_forward.senior`)}
                                        <br /> {prizes.expensive} {t(`modals.gate_options.go_forward.executive`)}
                                        <br /> $ {prizes.budget} <br />
                                        <br />
                                        {t(`modals.gate_options.go_forward.info_text3`)}
                                    </ParagraphContainer>
                                    <ButtonContainer style={{ marginRight: '15px' }}>
                                        <ExchangeButtonContainer
                                            style={{ width: '242px', height: '50px', border: 'none' }}
                                            onClick={() => {
                                                handleGateEnd(true, false);
                                                console.log("hi yoni3.0", delayCardIsTakenInGateControl, stage, actualGate, secondGateControlNeeded);
                                                toggleDelayCardAtFirstGateControl(true);
                                                toggleSecondGateNeeded(false);
                                                if (isTaskCompletedAtGate) {
                                                    commentGatePassedAfterCompletedTaskOnGate();
                                                    setIsTaskCompletedAtGate(false);
                                                }
                                            }}
                                        >
                                            <ExchangeButton>{t(`modals.gate_options.go_forward.button1`)}</ExchangeButton>
                                        </ExchangeButtonContainer>
                                    </ButtonContainer>
                                </>
                            )}
                            {gateTestResult === 'Delay' && (
                                <>
                                    <HeaderComponent>
                                        <TitleComponent>
                                            {t(`modals.gate_options.delay.info_title`)}
                                        </TitleComponent>
                                    </HeaderComponent>
                                    <ParagraphContainer style={{ paddingRight: '45px' }}>
                                        {t(`modals.gate_options.delay.info_text`)} {gateTestSteps.medium}
                                        &nbsp;
                                        <DiamondSm />
                                        &nbsp;{t(`modals.gate_options.delay.info_text2`)} {gateTestSteps.high}
                                        &nbsp;
                                        <DiamondSm />
                                        &nbsp;{t(`modals.gate_options.delay.info_text3`)}
                                    </ParagraphContainer>
                                    <ButtonContainer
                                        style={{
                                            marginLeft: '200px',
                                            width: '180px',
                                            height: '50px',
                                        }}
                                    >
                                        <ExchangeButtonContainer
                                            style={{ width: '180px', height: '50px', border: 'none' }}
                                            onClick={() => {
                                                commentDelayedAtGate();
                                                handleGateEnd(false, false);
                                            }}
                                        >
                                            <ExchangeButton>{t(`modals.gate_options.delay.button1`)}</ExchangeButton>
                                        </ExchangeButtonContainer>
                                    </ButtonContainer>
                                </>
                            )}
                            {gateTestResult === 'Go Back' && (
                                <>
                                    <HeaderComponent>
                                        <TitleComponent>{t(`modals.gate_options.go_back.info_title`)}</TitleComponent>
                                    </HeaderComponent>
                                    <ParagraphContainer style={{ paddingRight: '45px' }}>
                                        {t(`modals.gate_options.go_back.info_text`)} {gateTestSteps.low}
                                        &nbsp;
                                        <DiamondSm />
                                        &nbsp; {t(`modals.gate_options.go_back.info_text2`)} {gateTestSteps.medium}
                                        &nbsp;
                                        <DiamondSm />
                                        &nbsp;{t(`modals.gate_options.go_back.info_text3`)}
                                    </ParagraphContainer>
                                    <ButtonContainer
                                        style={{
                                            marginLeft: '200px',
                                            width: '180px',
                                            height: '50px',
                                        }}
                                    >
                                        <ExchangeButtonContainer
                                            style={{ width: '180px', height: '50px', border: 'none' }}
                                            onClick={() => {
                                                // movePlayerBackOnLowProjectValue();
                                                handleGateEnd(false, false, commentReturnFromGate);
                                            }}
                                        >
                                            <ExchangeButton>{t(`modals.gate_options.go_back.button1`)}</ExchangeButton>
                                        </ExchangeButtonContainer>
                                    </ButtonContainer>
                                </>
                            )}
                            {gateTestResult === 'Project is cancelled!' && (
                                <>
                                    <HeaderComponent>
                                        <TitleComponent>{t(`modals.gate_options.cancel_project.info_title`)}</TitleComponent>
                                    </HeaderComponent>
                                    <ParagraphContainer style={{ paddingRight: '45px' }}>
                                        {t(`modals.gate_options.cancel_project.info_text`)} {gateTestSteps.low}
                                        &nbsp;
                                        <DiamondSm />
                                        <p dangerouslySetInnerHTML={{ __html: t(`modals.gate_options.cancel_project.info_text2`).replace(/\n/g, '<br/>') }}></p>
                                    </ParagraphContainer>
                                    <ButtonContainer
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <ExchangeButtonContainer
                                            style={{
                                                width: '180px',
                                                height: '54px',
                                                borderColor: '#005857',
                                            }}
                                            onClick={async () => {
                                                await commentProjectCanceled();
                                                handleGateEnd(false, false);
                                                toggleNeedsToStartNewGame(false);
                                            }}
                                        >
                                            <NewGameButton>{t(`modals.gate_options.cancel_project.button1`)}</NewGameButton>
                                        </ExchangeButtonContainer>
                                        <ExchangeButtonContainer
                                            style={{ width: '180px', height: '55px', border: 'none' }}
                                            disabled={disableBtn}
                                            onClick={async () => {
                                                await commentProjectCanceled();
                                                socketIO.emit("game-completed");  // - do not remove
                                                PDFExample();
                                                triviaToggle(false);
                                                toggleProject(3);
                                                toggleGate(false);
                                                toggleNeedsToStartNewGame(true);
                                                setDisableBtn(true);
                                                toggleRestartHasBeenMadeNow()
                                            }}
                                        >
                                            <ExchangeButton>{t(`modals.gate_options.cancel_project.button2`)}</ExchangeButton>
                                        </ExchangeButtonContainer>
                                    </ButtonContainer>
                                </>
                            )}
                        </BodyComponent>
                    </InnerGatesContainer>
                </InnerContainer >
            </>
        );
    }
    if (secondGateControlNeeded && stage != 3) {
        return (
            <>
                <InnerContainer
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        width: '500px',
                        height: '426px',
                    }}
                >
                    <HeaderComponent
                        style={{
                            width: '80%',
                            margin: '0 auto',
                            lineHeight: '18px',
                        }}
                    >
                        <TitleComponent>{t(`modals.gate.previously_delayed_gate.title`)}</TitleComponent>
                    </HeaderComponent>
                    <ParagraphContainer
                        style={{
                            width: '80%',
                            margin: '0 auto',
                            lineHeight: '21.5px',
                        }}
                    >
                        {t(`modals.gate.previously_delayed_gate.info_text`)}
                        <br />
                        <br />
                        {prizes.regular} {t(`modals.gate.previously_delayed_gate.regular`)} <br />
                        {prizes.senior} {t(`modals.gate.previously_delayed_gate.senior`)}
                        <br /> {prizes.expensive} {t(`modals.gate.previously_delayed_gate.executive`)}
                        <br /> $ {prizes.budget} <br />
                        <br />
                        {t(`modals.gate.previously_delayed_gate.info_text2`)}
                    </ParagraphContainer>
                    <ButtonContainer
                        style={{
                            width: '85%',
                            height: '55px',
                            margin: '0 auto',
                            paddingTop: '15px',
                        }}
                    >
                        <ExchangeButtonContainer
                            style={{
                                width: '252px',
                                height: '52px',
                                border: 'none',
                            }}
                            onClick={() => {
                                handleGateNumber(actualGate + 1);
                                handleGiveResourcesSecondGateControl();
                                console.log("hi yoni9.5", stage, actualGate);
                                triviaToggle(true);
                                SoundPlay(soundForFlipAndCards);
                                toggleSecondGateNeeded(false);
                                toggleGate(false);
                                console.log("hi yoni3.1", delayCardIsTakenInGateControl, stage, actualGate);
                                toggleDelayCardAtFirstGateControl(true);
                                if (isTaskCompletedAtGate) {
                                    setIsTaskCompletedAtGate(false);
                                }
                            }}
                        >
                            <ExchangeButton>{t(`modals.gate.previously_delayed_gate.button1`)} </ExchangeButton>
                        </ExchangeButtonContainer>
                    </ButtonContainer>
                </InnerContainer>
            </>

        );
    }
    if (stage === 5) {
        return (
            <ModalContainer>
                <Br />
                <TextContainer>
                    <HeaderText> {modalTitle} </HeaderText>
                    <ParagraphText> {modalContent} </ParagraphText>
                </TextContainer>
                <ButtonContainerLine>
                    <ModalButtonContainer onClick={() => toggleGate(false)}>
                        <GetStartedButton> Continue Playing</GetStartedButton>
                    </ModalButtonContainer>
                    <ModalButtonContainer onClick={() => isPlanning(true)}>
                        <GetStartedButton>Pause for Planning </GetStartedButton>
                    </ModalButtonContainer>
                </ButtonContainerLine>
            </ModalContainer>
        );
    }
    return null;
}
